import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent3: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Define end user profile</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Define end user profile
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <p className="fs-7">In this step you will get to a detailed description of the typical end-user within your beachhead market segment. This will be a composite of your end-user customer. Your end-user customer may also be the economic buyer—customer meaning that they pay you for your product—or they might not be.</p>

                    <p className="fs-7">However, focus first on the end-user customer because without them embracing the product, there is no value generated for which we can extract rent—either from that end user or from a third party.</p>

                    <p className="fs-7">Instead of trying to relentlessly push your product or service onto and into the market, this will continue your focus on the potential customer and thereby make it easier to build your business based on the customer you are serving.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Profile characteristics
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <p className="fs-7">It is vital you understand the following aspects about your end-user in order to create a description of a narrowly defined subset of end-users with similar characteristics and needs.</p>

                    <p className="fs-7">Don’t forget, nor be afraid, to go out and speak to real potential customers. Do good, direct customer research now and it will pay off later. You might feel that not all of them are relevant for your situation but err on the side of getting too much information rather than too little. In cases like gender, understand the percentage split between male and female.</p>

                    <p className="fs-7">The list of what you should know about your segment is not comprehensive nor is it customized to your situation. Use this as a guideline and modify to fit your situation. Look especially for characteristics that would make this end user unique and differentiate them from non-target users.</p>

                    <ol>
                      <li className="fs-7">gender</li>
                      <li className="fs-7">age range (or generation)</li>
                      <li className="fs-7">income range</li>
                      <li className="fs-7">what motivates them</li>
                      <li className="fs-7">geographic area</li>
                      <li className="fs-7">where they live (urban, suburban, rural, nomad etc.)</li>
                      <li className="fs-7">where they work</li>
                      <li className="fs-7">education/degrees</li>
                      <li className="fs-7">what they fear most</li>
                      <li className="fs-7">who their hero is</li>
                      <li className="fs-7"> where they go on vacation</li>
                      <li className="fs-7">where they go out for dinner</li>
                      <li className="fs-7">what newspapers they read</li>
                      <li className="fs-7">what websites they visit</li>
                      <li className="fs-7">what TV shows they watch</li>
                      <li className="fs-7">why they are buying this product (savings, image, peer pressure, productivity)</li>
                      <li className="fs-7">what makes them special and identifiable</li>
                      <li className="fs-7">what their story is.</li>
                    </ol>

                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>
      
  );
};

export { StepContent3 };
